export default [
  {
    path: "/queue",
    component: () =>
      import(/* webpackChunkName: "queue" */ "@/views/global/Clear"),
    meta: { layout: "auth" },
    children: [
      {
        path: ":orgSlug/:partyId",
        name: "queue.party",
        component: () =>
          import(/* webpackChunkName: "queue" */ "@/views/queue/QueueParty"),
      },
      {
        path: "*",
        redirect: "/queue",
      },
    ],
  },
];
